import React, { useCallback } from 'react';

import { reportError } from '@this/lib/bugsnag';
import { Button } from './shared/ui/inputs/button';
import { useAITTheme } from './shared/ui/theme/provider';

interface Props {
  index: number;
  items: string[];
  onChange: (i: number) => void;
}

const SimpleSelectorCustom: React.FC<Props> = ({ index, items, onChange }) => {
  const { theme } = useAITTheme();
  const { colors } = theme.tokens;
  const handleItemClick = useCallback(
    (i: number, e: React.MouseEvent<HTMLElement>) => {
      e.preventDefault();
      onChange(i);
    },
    [onChange]
  );

  const getButtonStyle = useCallback(
    (i: number) => {
      const baseStyle = {
        marginRight: '10px',
        padding: '10px 5px',
        border: `solid 1px ${colors.brand.primary}`,
        fontSize: '14px',
        textAlign: 'center' as const,
        cursor: 'pointer',
        width: '200px',
        borderRadius: '7px',
        color: index === i ? colors.common.white : colors.brand.primary,
        backgroundColor: index === i ? colors.brand.primary : colors.common.white
      };
      return baseStyle;
    },
    [index]
  );

  try {
    return (
      <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
        {items.map((item, i) => (
          <React.Fragment key={`item-${i}`}>
            {item.length > 0 && (
              <Button style={getButtonStyle(i)} onClick={e => handleItemClick(i, e)}>
                {item}
              </Button>
            )}
          </React.Fragment>
        ))}
      </div>
    );
  } catch (e) {
    reportError(e);
    return null;
  }
};

export default SimpleSelectorCustom;
